module.exports = __webpack_public_path__ + "static/media/lock-icon.53c1d912.png";